import logo from "../src/images/logo.png";
import gplay from "../src/images/gplay.png";
import meubikefit from "../src/images/meubikefit.png";
import burninfix from "../src/images/burninfix.png";
import meusgastos from "../src/images/meusgastos.png";
import meupcroda from "../src/images/meupcroda.png";
import burninfix1 from "../src/images/burninfix1.png";
import burninfix2 from "../src/images/burninfix2.png";
import burninfix3 from "../src/images/burninfix3.png";
import meubikefit1 from "../src/images/meubikefit1.png";
import meubikefit2 from "../src/images/meubikefit2.png";
import meubikefit3 from "../src/images/meubikefit3.png";
import meusgastos1 from "../src/images/meusgastos1.png";
import meusgastos2 from "../src/images/meusgastos2.png";
import meusgastos3 from "../src/images/meusgastos3.png";
import "./App.css";

const date = new Date();

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="p1">
          <div>
            <div className="containerLogo">
              <img
                src={logo}
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/dev?id=7961800243445202083",
                    "_blank"
                  )
                }
                className="App-logo"
                alt="logo"
              />
              <h1 className="message">
                Aplicativos simples para facilitar o seu dia!
              </h1>
            </div>
          </div>
        </div>

        <div className="p2">
          <div className="mainAppContainer">
            <div className="appContent">
              <div className="containerTitle">
                <img
                  src={meubikefit}
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.simpleapps.meubikefit&hl=pt_BR",
                      "_blank"
                    )
                  }
                  className="App-logo2"
                  alt="logo"
                />
                <h1 className="title">Meu Bike Fit</h1>
                <p className="subtitle">
                  Ajuste a sua bicicleta com poucos toques e pedale melhor!
                </p>
              </div>
            </div>
            <div className="screenshotContent">
              <img src={meubikefit1} className="imgDescription" alt="logo" />
              <img src={meubikefit2} className="imgDescription" alt="logo" />
              <img src={meubikefit3} className="imgDescription" alt="logo" />
            </div>
          </div>
        </div>

        <div className="p3">
          <div className="mainAppContainer">
            <div className="appContent">
              <div className="containerTitle">
                <img
                  src={burninfix}
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.simpleapps.burninfix&hl=pt_BR",
                      "_blank"
                    )
                  }
                  className="App-logo2"
                  alt="logo"
                />
                <h1 className="title">Burn-in Fix</h1>
                <p className="subtitle">
                  Corrija de maneira simples e direta os defeitos visuais de
                  tela causados pelo Ghosting e Burn-in
                </p>
              </div>
            </div>
            <div className="screenshotContent">
              <img src={burninfix1} className="imgDescription" alt="logo" />
              <img src={burninfix2} className="imgDescription" alt="logo" />
              <img src={burninfix3} className="imgDescription" alt="logo" />
            </div>
          </div>
        </div>

        <div className="p4">
          <div className="mainAppContainer">
            <div className="appContent">
              <div className="containerTitle">
                <img
                  src={meusgastos}
                  onClick={() =>
                    window.open(
                      "https://play.google.com/store/apps/details?id=com.simpleapps.meusgastos&hl=pt_BR",
                      "_blank"
                    )
                  }
                  className="App-logo2"
                  alt="logo"
                />
                <h1 className="title">Meus Gastos</h1>
                <p className="subtitle">
                  Controle seus gastos financeiros, gere relatórios e muito mais
                  de maneira fácil e rápida, seja no dinheiro ou cartão!
                </p>
              </div>
            </div>
            <div className="screenshotContent">
              <img src={meusgastos1} className="imgDescription" alt="logo" />
              <img src={meusgastos2} className="imgDescription" alt="logo" />
              <img src={meusgastos3} className="imgDescription" alt="logo" />
            </div>
          </div>
        </div>

        <div className="p5">
          <div className="footer">
            <h1 className="message" style={{ marginTop: 36 }}>
              Simplifique o seu dia a dia com um dos nossos aplicativos!
            </h1>
            <div className="appList">
              <img
                src={meubikefit}
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.simpleapps.meubikefit&hl=pt_BR",
                    "_blank"
                  )
                }
                className="App-logo2"
                alt="logos"
              />
              <img
                src={meusgastos}
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.simpleapps.meusgastos&hl=pt_BR",
                    "_blank"
                  )
                }
                className="App-logo2"
                alt="logos"
              />
              <img
                src={burninfix}
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.simpleapps.burninfix&hl=pt_BR",
                    "_blank"
                  )
                }
                className="App-logo2"
                alt="logos"
              />
              <img
                src={meupcroda}
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.app.meupcroda&hl=pt_BR",
                    "_blank"
                  )
                }
                className="App-logo2"
                alt="logos"
              />
            </div>
            <p className="footerText">Acesse nossa loja!</p>
            <img
              src={gplay}
              className="gplay"
              alt="gplay"
              onClick={() =>
                window.open(
                  "https://play.google.com/store/apps/dev?id=7961800243445202083",
                  "_blank"
                )
              }
            />
            <p style={{ fontWeight: "300", marginTop: 32, marginBottom: 0 }}>
              {date.getFullYear()}. SimpleApps and Tools.
            </p>
          </div>
        </div>

        <div className="p6" />
      </header>
    </div>
  );
}

export default App;
